import {DRAWER_COLLAPSED_WIDTH_LG, DRAWER_WIDTH,} from "../../../../components/main/drawer/DrawerConstants.ts";

export const GOLDEN_RECORD_CLUSTER_MENU_WIDTH_PX = 256;

export const MAIN_DRAWER_COLLAPSED_WIDTH_PX = DRAWER_COLLAPSED_WIDTH_LG + 1;

export function getMainDrawerWidthPx(isDrawerOpen: boolean): number {
    return isDrawerOpen ? DRAWER_WIDTH : MAIN_DRAWER_COLLAPSED_WIDTH_PX;
}

export function getGoldenRecordClusterToggleLeftPx(
    isMainDrawerOpen: boolean,
    isClusterMenuCollapsed: boolean,
    toggleButtonSizePx: number,
): number {
    const mainDrawerWidth = getMainDrawerWidthPx(isMainDrawerOpen);
    const clusterMenuWidth = isClusterMenuCollapsed ? 0 : GOLDEN_RECORD_CLUSTER_MENU_WIDTH_PX;
    return mainDrawerWidth + clusterMenuWidth - toggleButtonSizePx / 2;
}
